import script from "./CCI.vue?vue&type=script&lang=js"
export * from "./CCI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__